import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "MaintenanceDutyDashboardPage" */
	'pages/vehicle/MaintenanceDuty/MaintenanceDutyDashboardPage'));

export default [{ component, exact: true, path: '/maintenance_duties/:maintenanceDutyId' }];